import { initializeApp as a } from "firebase/app";
var e, E, t, I, _, i;
const r = {
  apiKey: (e = import.meta.env) == null ? void 0 : e.VITE_FIREBASE_API_KEY,
  authDomain: (E = import.meta.env) == null ? void 0 : E.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: (t = import.meta.env) == null ? void 0 : t.VITE_FIREBASE_PROJECT_ID,
  storageBucket: (I = import.meta.env) == null ? void 0 : I.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: (_ = import.meta.env) == null ? void 0 : _.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: (i = import.meta.env) == null ? void 0 : i.VITE_FIREBASE_APP_ID
};
function n() {
  return a(r);
}
export {
  n as s
};
